











import { defineComponent } from '@vue/composition-api';
import { priceToString } from '@/util/CurrencyHelper';

export default defineComponent({
    name: 'Price',
    props: {
        currencyCode: { type: String, required: true },
        amount: { type: String, required: true },
        vat: { type: String, required: true },
        ono: { type: String, required: true },
        tradeExplain: { type: String, required: true }
    },
    computed: {
        formattedPrice: function () {
            return priceToString({
                CurrencyCode: this.currencyCode,
                Amount: this.amount,
                ToPoundRate: '1',
                Vat: this.vat,
                ONO: this.ono,
                TradeExplain: this.tradeExplain
            });
        }
    }
});
